// extracted by mini-css-extract-plugin
export default {"sortListProductSection":"Sort_sortListProductSection__4dYn3","sortproductDataLength":"Sort_sortproductDataLength__-fy0S","sortSelectionForm":"Sort_sortSelectionForm__oOAnU"};